import { getUser } from '@/api/user'

export default {
  state: {
    loading: false,
    loaded: false,
    user: null
  },
  getters: {
    userLoading: state => state.loading,
    userLoaded: state => state.loaded,
    user: state => state.user
  } ,
  mutations: {
    WATCH_USER_LOADING (state, value) { state.loading = value },
    WATCH_USER_LOADED (state, value) { state.loaded = value },
    WATCH_USER (state, value) { state.user = value }
  },
  actions: {
    fetchUser ({commit}) {
      commit('WATCH_USER_LOADING', true)
      return getUser()
        .then((response) => commit('WATCH_USER', response.data))
        .finally(() => {
          commit('WATCH_USER_LOADING', false)
          commit('WATCH_USER_LOADED', true)
        })
    }
  }
}